"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBtnTooltip = IconBtnTooltip;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _material = require("@mui/material");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var commonIcons = {
  CLOSE: {
    icon: 'close',
    title: 'Close'
  },
  CREATE: {
    icon: 'create',
    title: 'Edit'
  },
  EXPAND_LESS: {
    icon: 'expand_less',
    title: 'Collapse'
  },
  EXPAND_MORE: {
    icon: 'expand_more',
    title: 'Expand'
  },
  MORE_VERT: {
    icon: 'more_vert',
    title: 'Menu'
  },
  PRINT: {
    icon: 'print',
    title: 'Print'
  }
};

function getTitle(icon) {
  switch (icon) {
    case commonIcons.CLOSE.icon:
      return commonIcons.CLOSE.title;

    case commonIcons.CREATE.icon:
      return commonIcons.CREATE.title;

    case commonIcons.EXPAND_LESS.icon:
      return commonIcons.EXPAND_LESS.title;

    case commonIcons.EXPAND_MORE.icon:
      return commonIcons.EXPAND_MORE.title;

    case commonIcons.MORE_VERT.icon:
      return commonIcons.MORE_VERT.title;

    case commonIcons.PRINT.icon:
      return commonIcons.PRINT.title;

    default:
      return '';
  }
}

function IconBtnTooltip(_ref) {
  var buttonProps = _ref.buttonProps,
      icon = _ref.icon,
      iconProps = _ref.iconProps,
      onClick = _ref.onClick,
      title = _ref.title,
      tooltipProps = _ref.tooltipProps;
  return /*#__PURE__*/_react["default"].createElement(_material.Tooltip, _extends({
    title: title ? title : getTitle(icon)
  }, tooltipProps), /*#__PURE__*/_react["default"].createElement(_material.IconButton, _extends({
    "aria-label": title ? title : getTitle(icon),
    component: !buttonProps.disabled ? 'button' : 'div' // fixes console warning when wrapping IconButton with Tooltip
    ,
    onClick: onClick
  }, buttonProps), /*#__PURE__*/_react["default"].createElement(_material.Icon, iconProps, icon)));
}

var icons = Object.values(commonIcons).map(function (icon) {
  return icon.icon;
});
IconBtnTooltip.defaultProps = {
  buttonProps: {
    disabled: false
  }
};
IconBtnTooltip.propTypes = {
  buttonProps: _propTypes["default"].object,
  icon: _propTypes["default"].oneOfType([_propTypes["default"].object, // MUI icons
  _propTypes["default"].string // Google Material icons
  ]).isRequired,
  iconProps: _propTypes["default"].object,
  onClick: _propTypes["default"].func.isRequired,
  title: (0, _reactRequiredIf["default"])(_propTypes["default"].string, function (props) {
    return !icons.includes(props.icon);
  }),
  // no title required for most common icons
  tooltipProps: _propTypes["default"].object
};
var _default = IconBtnTooltip;
exports["default"] = _default;